var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"v-card__content",class:{ 'v-card__content--full': _vm.props.full }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }